<template>
  <section class="section-base form-section-base">
    <v-container>
      <div class="form-base">
        <v-row>
          <v-col cols="12">
            <div class="form-base__title">
              Информация о электронном документе (пакете электронных документов)
            </div>
          </v-col>
          <v-col cols="12">
            <div class="alert-base mt-0 mb-6">
              <v-alert
                icon="mdi-exclamation-thick"
                prominent
                text
                dense
                type="info"
                color="red"
              >
                Внимание! Файл будет удален через 10 дней, если заявление не
                будет направлено в обработку нотариусом.
              </v-alert>
            </div>
            <AttachDocumentMultiple
              v-model="$v.storageDocument.$model"
              :error-messages="getValidationErrorText($v.storageDocument)"
              :acceptFile="['.zip']"
              singleZip
              :max-file-size="1024"
              :max-length="255"
            />
          </v-col>
          <v-col cols="4">
            <DateFieldCustom
              label="Срок хранения по"
              :value="$v.storageAcceptDetails.storagePeriodTo.$model"
              :errorMessage="$v.storageAcceptDetails.storagePeriodTo"
              @change="$v.storageAcceptDetails.storagePeriodTo.$model = $event"
              :max="dateToMax(100)"
              :min="new Date().toISOString()"
            />
          </v-col>
        </v-row>
      </div>

      <Footer
        @next-btn-click="btnSaveClickHandler(StepDirection.NEXT)"
        @prev-btn-click="btnSaveClickHandler(StepDirection.PREV)"
        :loading-next="loadingNext"
      />
    </v-container>
  </section>
</template>

<script>
import cloneDeep from 'clone-deep';
import { dateRevers } from '@/utils/common';
import { maxLength, required, requiredIf } from 'vuelidate/lib/validators';

import AttachDocumentMultiple from '@/components/base/AttachDocument/AttachDocumentMultiple';
import DateFieldCustom from '@/components/base/DateFieldCustom.vue';
import {
  EMOJI,
  DATE_CORRECT_PERIOD,
  DATE_MAX_100,
  getValidationErrorText,
} from '@/utils/validate';
import { checkInvalid, leaveStep, Text } from '@/utils/services';
import { dateToMax, dateWithoutTime } from '@/utils/common';
import { ServicesModule } from '@/store/modules/services';
import Footer from '@/components/services/elements/Footer';
import { StepDirection, StepName } from '@/types/services';
import { StorageAcceptStep } from '@/constants';

export default {
  name: 'StorageAcceptDetails',
  components: {
    Footer,
    AttachDocumentMultiple,
    DateFieldCustom,
  },
  props: {
    loadingNext: {
      type: Boolean,
      required: true,
    },
  },
  data: () => ({
    StepDirection,
    Text,
    dateWithoutTime,
    dateRevers,
    StepName,
    leaveStep,
    getValidationErrorText,
    dateToMax,
    invalidFields: [],
    storageAcceptDetails: {
      storagePeriodTo: '',
      note: '',
      hasPrivilege: false,
    },
    storageDocument: [],
  }),
  validations() {
    return {
      storageAcceptDetails: {
        storagePeriodTo: {
          required,
          DATE_MAX_100,
          DATE_CORRECT_PERIOD: DATE_CORRECT_PERIOD(
            dateWithoutTime(new Date().toISOString()),
            this.storageAcceptDetails.storagePeriodTo
          ),
        },
        note: {
          required: requiredIf(() => this.storageAcceptDetails.hasPrivilege),
          maxLength: maxLength(4000),
          EMOJI,
        },
        hasPrivilege: {},
      },
      storageDocument: {
        DOCUMENTS_MIN_LENGTH: required,
      },
    };
  },
  created() {
    this.prefillDraft();
  },
  methods: {
    prefillDraft() {
      if (ServicesModule.statement.storageDocument) {
        this.storageDocument[0] = cloneDeep(
          ServicesModule.statement.storageDocument
        );
      }

      if (ServicesModule.statement.storageAcceptDetails) {
        this.storageAcceptDetails = cloneDeep(
          ServicesModule.statement.storageAcceptDetails
        );
      }
    },
    touchFields() {
      this.invalidFields = [];
      this.$v.$touch();
      checkInvalid(this.$v, this.invalidFields);
    },

    assemblyModel() {
      return {
        storageAcceptDetails: cloneDeep(this.storageAcceptDetails),
        storageDocument: { ...this.storageDocument[0] },
      };
    },

    btnSaveClickHandler(direction) {
      leaveStep({
        stepThis: this,
        direction,
        step: StorageAcceptStep.STORAGE_ACCEPT_DETAILS,
      });
    },
  },
};
</script>
